import { PRIVACY_POLICY } from "../utils/privacyPolicy";
import { romanize } from "../utils/helpers";
import { AcceptTerms, Section } from "./TermsAndConditions";
import constants from "../utils/constants";

export default function PrivacyPolicy({canAccept}) {
  const summaryWithLineBreaks = PRIVACY_POLICY.summary.replace(/\n/g, "<br/>");
  return (
    <div className="p-4">
      <h2 className="text-3xl font-semibold">Privacy Policy</h2>
      <p
        className="mt-4"
        dangerouslySetInnerHTML={{ __html: summaryWithLineBreaks }}
      ></p>

      {PRIVACY_POLICY.sections.map((x, i) => {
        return (
          <Section
            romanNumeral={romanize(i + 1)}
            header={x.header}
            paragraph={x.paragraph}
          />
        );
      })}
      {!!canAccept && (
        <AcceptTerms
          endpoint={"user/AcceptPrivacyPolicy"}
          checkboxText={`I accept ${constants.APP_NAME}'s Privacy Policy`}
          successMessage={"Terms and conditions accepted"}
          errorMessage={"Unable to accept terms and conditions"}
        />
      )}
    </div>
  );
}
